;(function setupInvoiceListLuxPropertyEmoji() {
  const LUX_PROPERTY_PREFIX_RE = /^(✅|❌|⚠️)\s+/

  function luxInvoiceListUrlPath(u) {
    try {
      return new URL(u, window.location.href).pathname
    } catch {
      return ''
    }
  }

  const INVOICES_COLLECTION_SUFFIX = '/pmp-accounting/api/v1/invoices'

  function isInvoiceListCollectionGet(urlString, method) {
    if ((method || 'GET').toUpperCase() !== 'GET' || !urlString) return false
    const path = luxInvoiceListUrlPath(urlString)
    const pos = path.indexOf(INVOICES_COLLECTION_SUFFIX)
    if (pos === -1) return false
    const tail = path.slice(pos + INVOICES_COLLECTION_SUFFIX.length)
    if (tail !== '' && tail !== '/') return false
    return true
  }

  function rememberLastInvoiceListUrl(urlString) {
    try {
      const u = new URL(urlString, window.location.href)
      u.searchParams.delete('_luxListT')
      window.Lux_lastInvoiceListCollectionGetUrl = u.href
    } catch (e) {}
  }

  function cacheLuxPropertyDisplaysFromPayload(data) {
    const content = data && data.content
    if (!Array.isArray(content)) return

    if (!window.Lux_invoiceListPropertyDisplayByKey) {
      window.Lux_invoiceListPropertyDisplayByKey = Object.create(null)
    }
    const map = window.Lux_invoiceListPropertyDisplayByKey

    for (let i = 0; i < content.length; i++) {
      const item = content[i]
      const hid = item.invoiceHrId != null && item.invoiceHrId !== '' ? String(item.invoiceHrId) : null
      const iid = item.id != null && item.id !== '' ? String(item.id) : null
      const display = item.propertyName
      if (typeof display === 'string' && LUX_PROPERTY_PREFIX_RE.test(display)) {
        if (hid) map[hid] = display
        if (iid) map[iid] = display
      } else {
        if (hid) delete map[hid]
        if (iid) delete map[iid]
      }
    }

    if (typeof window.Lux_scheduleInvoiceListPropertyEmojiRestore === 'function') {
      window.Lux_scheduleInvoiceListPropertyEmojiRestore()
    }
  }

  function luxStripPropertyEmojiPrefix(label) {
    if (typeof label !== 'string') return ''
    return label.replace(LUX_PROPERTY_PREFIX_RE, '').trim()
  }

  function luxNormalizeForPropertyMatch(s) {
    return s.replace(/\s+/g, ' ').trim()
  }

  function luxPrimaryLineMatchesRaw(primaryLine, raw) {
    const a = luxNormalizeForPropertyMatch(luxStripPropertyEmojiPrefix(primaryLine))
    const b = luxNormalizeForPropertyMatch(raw)
    if (!a || !b) return false
    if (a === b) return true
    if (a.endsWith('…') || a.endsWith('...')) {
      const prefix = a.replace(/(\u2026|\.\.\.)$/, '').trim()
      if (prefix && b.startsWith(prefix)) return true
    }
    if (b.endsWith('…') || b.endsWith('...')) {
      const prefix = b.replace(/(\u2026|\.\.\.)$/, '').trim()
      if (prefix && a.startsWith(prefix)) return true
    }
    if (a.length >= 12 && (b.startsWith(a) || a.startsWith(b))) return true
    return false
  }

  function luxInvoiceKeysFromListRow(tr) {
    const keys = []
    const rk = tr.getAttribute('data-row-key')
    if (rk && rk !== '0' && rk !== '') keys.push(String(rk))

    const anchors = tr.querySelectorAll('a[href]')
    for (let i = 0; i < anchors.length; i++) {
      const href = anchors[i].getAttribute('href') || ''
      const patterns = [
        /\/invoice\/edit\/([^/?#]+)/,
        /\/payments\/invoice\/([^/?#]+)/,
        /\/invoice\/([^/?#]+)\/edit/,
        /invoiceHrId=([^&]+)/,
      ]
      for (let p = 0; p < patterns.length; p++) {
        const m = href.match(patterns[p])
        if (m && m[1]) keys.push(decodeURIComponent(m[1]))
      }
    }
    return keys
  }

  function luxPatchObjektPrimaryText(td, displayName) {
    const raw = luxStripPropertyEmojiPrefix(displayName)
    const want = displayName.trim()
    if (!raw) return false

    const links = td.querySelectorAll('a')
    for (let i = 0; i < links.length; i++) {
      const link = links[i]
      const lt = link.textContent.trim()
      if (lt && luxPrimaryLineMatchesRaw(lt, raw)) {
        if (lt === want) return true
        link.textContent = want
        return true
      }
    }

    const lines = td.textContent.split(/\r?\n/)
    const primary = (lines[0] || '').trim()
    if (!luxPrimaryLineMatchesRaw(primary, raw)) return false
    if (primary === want) return true

    const stack = [td]
    while (stack.length) {
      const node = stack.pop()
      for (let c = node.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === Node.TEXT_NODE) {
          const t = c.textContent.trim()
          if (t && luxPrimaryLineMatchesRaw(t, raw)) {
            c.textContent = want
            return true
          }
        } else if (c.nodeType === Node.ELEMENT_NODE) {
          stack.push(c)
        }
      }
    }

    if (lines.length > 1) {
      td.textContent = [want, ...lines.slice(1)].join('\n')
    } else {
      td.textContent = want
    }
    return true
  }

  window.Lux_restoreInvoiceListPropertyEmojis = function () {
    const map = window.Lux_invoiceListPropertyDisplayByKey
    const root = document.getElementById('invoiceList')
    if (!root || !map) return

    const rows = root.querySelectorAll('tr')
    for (let r = 0; r < rows.length; r++) {
      const tr = rows[r]
      if (!tr.querySelector('td')) continue
      const keys = luxInvoiceKeysFromListRow(tr)
      let displayName = null
      for (let k = 0; k < keys.length; k++) {
        if (map[keys[k]]) {
          displayName = map[keys[k]]
          break
        }
      }
      if (!displayName) continue

      const tds = tr.querySelectorAll('td')
      for (let i = 0; i < tds.length; i++) {
        if (luxPatchObjektPrimaryText(tds[i], displayName)) break
      }
    }
  }

  let luxInvoiceEmojiRestoreTimer = null
  window.Lux_scheduleInvoiceListPropertyEmojiRestore = function () {
    if (luxInvoiceEmojiRestoreTimer) clearTimeout(luxInvoiceEmojiRestoreTimer)
    luxInvoiceEmojiRestoreTimer = setTimeout(function () {
      luxInvoiceEmojiRestoreTimer = null
      window.Lux_restoreInvoiceListPropertyEmojis()
    }, 120)
  }

  function luxRefetchInvoiceListEmojiCache() {
    const url = window.Lux_lastInvoiceListCollectionGetUrl
    if (!url) return Promise.resolve()
    let token
    try {
      token = JSON.parse(localStorage.getItem('auth') || '{}').token
    } catch (e) {
      return Promise.resolve()
    }
    if (!token) return Promise.resolve()

    const bust = (url.includes('?') ? '&' : '?') + '_luxListT=' + Date.now()
    return fetch(url + bust, {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json',
      },
      credentials: 'include',
      cache: 'no-store',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Lux invoice list refetch failed')
        return r.json()
      })
      .then(cacheLuxPropertyDisplaysFromPayload)
  }

  function luxRefetchInvoiceListAndRestore() {
    return luxRefetchInvoiceListEmojiCache()
      .then(function () {
        window.Lux_restoreInvoiceListPropertyEmojis()
      })
      .catch(function () {
        if (typeof window.Lux_scheduleInvoiceListPropertyEmojiRestore === 'function') {
          window.Lux_scheduleInvoiceListPropertyEmojiRestore()
        }
      })
  }

  window.Lux_refetchInvoiceListEmojiCache = luxRefetchInvoiceListEmojiCache

  function triggersInvoiceListEmojiRefresh(method, urlString) {
    const m = (method || 'GET').toUpperCase()
    if (m === 'GET' || m === 'HEAD' || m === 'OPTIONS') return false
    if (!urlString) return false
    try {
      const path = new URL(urlString, window.location.href).pathname
      if (path.includes('/api/invoiceNotes/set')) return true
      if (path.includes('/pmp-accounting/api/v1/invoices')) return true
      if (path.includes('/api/invoices/') && path.includes('capex-request-approval')) return true
      return false
    } catch (e) {
      return false
    }
  }

  function luxOnInvoiceListRelatedMutation(method, urlString) {
    if (!triggersInvoiceListEmojiRefresh(method, urlString)) return
    setTimeout(function () {
      luxRefetchInvoiceListAndRestore()
    }, 0)
  }

  function luxHandleXhrLoad(xhr) {
    try {
      if (xhr.status < 200 || xhr.status >= 300) return
      const url = xhr._luxUrl
      const method = xhr._luxMethod || 'GET'
      if (typeof url !== 'string') return

      let fullUrl = url
      try {
        fullUrl = new URL(url, window.location.href).href
      } catch (e) {
        return
      }

      if (isInvoiceListCollectionGet(fullUrl, method)) {
        rememberLastInvoiceListUrl(fullUrl)
        try {
          const data = JSON.parse(xhr.responseText)
          cacheLuxPropertyDisplaysFromPayload(data)
        } catch (e) {}
      }

      luxOnInvoiceListRelatedMutation(method, fullUrl)
    } catch (e) {}
  }

  const xhrOpen = XMLHttpRequest.prototype.open
  const xhrSend = XMLHttpRequest.prototype.send

  XMLHttpRequest.prototype.open = function (method, url) {
    this._luxMethod = method
    this._luxUrl = url
    return xhrOpen.apply(this, arguments)
  }

  XMLHttpRequest.prototype.send = function () {
    const xhr = this
    const onLoad = function () {
      xhr.removeEventListener('load', onLoad)
      luxHandleXhrLoad(xhr)
    }
    xhr.addEventListener('load', onLoad)
    return xhrSend.apply(this, arguments)
  }

  window.addEventListener('popstate', function () {
    setTimeout(function () {
      luxRefetchInvoiceListAndRestore()
    }, 0)
  })

  const previousFetch = window.fetch
  window.fetch = async function () {
    const args = arguments
    const req = args[0]
    const urlString = typeof req === 'string' ? req : req && req.url
    const init = args[1] || {}
    const method = (typeof req !== 'string' && req && req.method) || init.method || 'GET'

    if (urlString && isInvoiceListCollectionGet(urlString, method)) {
      rememberLastInvoiceListUrl(urlString)
    }

    const response = await previousFetch.apply(this, args)

    try {
      if (urlString && triggersInvoiceListEmojiRefresh(method, urlString) && response.ok) {
        luxOnInvoiceListRelatedMutation(method, urlString)
      }

      if (!urlString || !isInvoiceListCollectionGet(urlString, method)) {
        return response
      }
      const cloned = response.clone()
      cloned.json().then(cacheLuxPropertyDisplaysFromPayload).catch(function () {})
    } catch (e) {}

    return response
  }
})()
